import { useContext } from 'react';

import { LifeAreaFormContext } from './life-area-form-context';

export const useOpenEditLifeAreaDialog = () => {
  const { onEditLifeArea } = useContext(LifeAreaFormContext);

  return onEditLifeArea;
};
